import { render, staticRenderFns } from "./incomedetail.vue?vue&type=template&id=0060e939&scoped=true&"
import script from "./incomedetail.vue?vue&type=script&lang=js&"
export * from "./incomedetail.vue?vue&type=script&lang=js&"
import style0 from "./incomedetail.vue?vue&type=style&index=0&id=0060e939&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060e939",
  null
  
)

export default component.exports